import { Color } from '../enums/color.enum';

export enum ThemeType {
  enTheme = 'enTheme',
  uzTheme = 'uzTheme',
}

export interface Theme {
  '--main-color': Color;
  '--main-color-hover': Color;
  '--main-color-active': Color;
  '--text-color': Color;
  '--second-color': Color;
  '--second-color-hover': Color;
  '--second-color-active': Color;
  '--link-color': Color;
  '--link-color-hover': Color;
  '--link-color-active': Color;
  '--third-color': Color;
  '--table-gradient': Color;
  '--third-color-hover': Color;
  '--third-color-active': Color;
  '--secondary-button-text': Color;
  '--secondary-button-border': Color;
  '--secondary-button-hover': Color;
  '--secondary-button-active': Color;
  '--tech-tugs-bg': Color;
  '--tech-tugs-border': Color;
  '--bg-color-second': Color;
  '--vacancies-filter-bg': Color;
  '--label-text-color': Color;
  '--scrollbar-drag': Color;
  '--arrow-link-hover': Color;
  '--focused-border-color': Color;
  '--bullet-color': Color;
}
